export const DEFAULT_PLACE = 'OM';

export const serviceType = {
	GSM: 0,
	MOBILE_INTERNET_PLANS: 1,
	CPN: 2,
	TARIFF_PLAN: 3,
	CREDIT_LIMIT: 4,
};

export const MIN_LINE_NAME_LENGTH = 5;
export const forBiddenWords = ["allah", "god", "sex", "qaboos", "binladen", "sultan", "porn"]
export const gisDetailsForDev = "Governorate=Muscat,Wilayat=Muscat,Town=Muscat,BuildingNo=0,WayNo=19,exchange=,cabinet=,DP=,OBCTAGNUMBER=,OBCOLT=,OBCFDHNUMBER=,OLT=,FDH=,MDU=,AP=,FTP=,MSAN=,LAT=23.61211672934759,LONG=58.59445452690125,NORTH=2612190.3056, EAST=662670.4080,ITDD = Yes,OTDD = No,WFBB4GIn = No,WFBB4GOut = No,WFBB3G = Yes,5GITDD = Yes,5GOTDD = Yes,4G=,3G=,remarks=,status=Red,networktype="
export const portalStg = 'https://authoring.omantel.om/'
export const portalPrd = 'https://portal.omantel.om/'
export const termsAndConstionsUrl = '/tc-fiber-pro'